<template>
  <div class="is-koyou-hoken edit-item" v-if="editingData && options">
    
    <div class="head"><b>雇用保険</b></div>
    <div class="data">
      <select-box :options="options?.boolean_type" v-model="editingData.is_koyou_hoken" class="small" :disabled="disabled"></select-box>
      <p class="current-data">{{ currentData?.is_koyou_hoken ? '有' : '無'}}</p>
    </div>

  </div>
</template>

<script lang="ts">
import { KoyouKeiyakuOption } from '@/types/KoyouKeiyaku';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    options: {
      type: Object as () => KoyouKeiyakuOption | null,
      require: true,
      default: null
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';

</style>
